import { cn } from '../utils/cn';

interface SummaryItem {
  label: string;
  value: string | number;
  color?: string;
}

interface SummaryCardProps {
  items: SummaryItem[];
  className?: string;
  columns?: number;
}

export default function SummaryCard({ items, className, columns = 2 }: SummaryCardProps) {
  return (
    <div className={cn('grid gap-3', columns === 2 ? 'grid-cols-2' : columns === 3 ? 'grid-cols-3' : 'grid-cols-4', className)}>
      {items.map((item, i) => (
        <div key={i} className="rounded-lg bg-surface-card-hover p-3">
          <p className="text-xs text-content-muted">{item.label}</p>
          <p className={cn('text-lg font-bold mt-1', item.color || 'text-content-primary')}>{item.value}</p>
        </div>
      ))}
    </div>
  );
}
